import React from 'react'
import { Modal } from 'react-bootstrap';
import { snackbar } from "@mobiscroll/react5";
import next_icon from "src/assets/Next icon.svg";
import { Input } from "@mobiscroll/react5";
import { updateUserAttribute, confirmUserAttribute, sendUserAttributeVerificationCode } from 'aws-amplify/auth';
import Loader from "src/components/Dashboard/common/Loader";
import OtpInput from 'react-otp-input';

const VerificationPopup = (props) => {
    const { show, closePopup, verifyType, refetch, currentAttributeValue } = props;

    const [value, setValue] = React.useState("");
    const [codeSent, setCodeSent] = React.useState(false);
    const [code, setCode] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");

    const attributeKey = verifyType === "email" ? "email" : "phone_number";

    const resetState = () => {
        setValue("")
        setCode("")
        setCodeSent(false)
        setError("")
        setLoading(false)
    }

    React.useEffect(() => {
        if (!show) return;
        resetState();
    }, [show, verifyType]);

    const validateInput = () => {
        if (attributeKey === "email") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(value);
        } else {
            // Expect E.164, e.g., +12065550100
            const phoneRegex = /^\+[1-9]\d{6,14}$/;
            return phoneRegex.test(value);
        }
    }

    const onSendCode = async () => {
        setError("")
        if (!validateInput()) {
            setError(attributeKey === "email" ? "Enter a valid email address" : "Please add country code. E.g., +91");
            return;
        }
        setLoading(true)

        const isNewValue = value !== currentAttributeValue;
        try {
            let output;

            if (isNewValue) {
                console.log("Calling: updateUserAttribute");

                output = await updateUserAttribute({
                    userAttribute: {
                        attributeKey: attributeKey,
                        value: value
                    }
                });
            } else {
                console.log("Calling: sendUserAttributeVerificationCode");
                output = await sendUserAttributeVerificationCode({
                    userAttributeKey: attributeKey
                });
            }

            console.log("Code sent successfully", output)
            setCodeSent(true)
            snackbar({ message: `Confirmation code sent to your ${label}`, color: "success" })
        } catch (e) {
            const msg = e?.message || "Failed to send confirmation code";
            setError(msg)
            snackbar({ message: msg, color: "danger" })
        } finally {
            setLoading(false)
        }
    }

    const onVerify = async () => {
        setError("")
        if (!code || code.length < 4) {
            setError("Enter the verification code")
            return;
        }
        setLoading(true)
        try {
            await confirmUserAttribute({
                userAttributeKey: attributeKey,
                confirmationCode: code
            })
            snackbar({ message: `${verifyType === 'email' ? 'Email' : 'Phone number'} verified successfully.`, color: "success" })
            if (typeof refetch === 'function') {
                await refetch()
            }
            closePopup()
        } catch (e) {
            const msg = e?.message || "Verification failed";
            setError(msg)
            snackbar({ message: msg, color: "danger" })
        } finally {
            setLoading(false)
        }
    }

    const handleOTPChange = (e) => {
        const value = e;
        setCode(value);
        if (value.length != 6) {
            setError("Invalid OTP, OTP must be 6 digits");
        } else {
            setError("");
        }
    };

    const label = verifyType === "email" ? "email" : "phone number";

    return (
        <>
            < Modal
                show={show}
                onHide={closePopup}
                backdrop="static"
                keyboard={false}
                dialogClassName="docg-modal"
                size="lg"
                centered
            >
                <Loader show={loading} />
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className="ModalTitle">{verifyType === "email" ? "Verify Email" : "Verify Phone Number"}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="overflow-auto">
                    <div className="mbsc-grid py-4">
                        <div className="mbsc-row">
                            <div className="mbsc-col-8 mx-auto">
                                {!codeSent && (
                                    <>
                                        <div className="right-signup-div">
                                            <p className="signup-link fs-4"><u>Step 1/2</u></p>
                                            <br />
                                            <p className="signup-link mt-2 fs-5">Enter {label} to verify.</p>
                                            <br />
                                            <div className="">
                                                <Input
                                                    labelStyle="floating"
                                                    inputStyle="underline"
                                                    value={value}
                                                    onChange={(e) => setValue(e.target.value)}
                                                />
                                                <br />
                                                {error ? (<span className="otp-error">{error}</span>) : ("")}
                                                <br />

                                                <button className="purple-button" onClick={onSendCode} disabled={loading}>
                                                    <img src={next_icon} alt="" />&nbsp;&nbsp; Continue
                                                </button>

                                            </div>
                                        </div>
                                    </>
                                )}

                                {codeSent && (
                                    <>
                                        <div className="right-signup-div">
                                            <p className="signup-link fs-4"><u>Step 2/2</u></p>
                                            <br />
                                            <p className="signup-link mt-2 fs-5">We've sent a confirmation code to your {label}.<br /> Enter it below to verify</p>
                                            <br />
                                            <div className="signup-wrapper-inner">
                                                <p style={{ fontSize: "16px" }} className="get-txt mt-4">
                                                    Enter OTP
                                                </p>
                                                <br />
                                                <OtpInput
                                                    onChange={handleOTPChange}
                                                    value={code}
                                                    numInputs={6}
                                                    hasErrored={error}
                                                    errorStyle={"otp-input-error"}
                                                    separator={<span>&emsp;</span>}
                                                    containerStyle={"otp-container"}
                                                    inputStyle={"form-input-otp"}
                                                    isInputNum={true}
                                                />
                                                <br />
                                                {error ? (
                                                    <span className="otp-error">{error}</span>
                                                ) : (
                                                    ""
                                                )}
                                                <br />

                                                <button className="purple-button" onClick={onVerify} disabled={loading}>
                                                    <img src={next_icon} alt="" />&nbsp;&nbsp; {loading ? 'Verifying...' : 'Verify'}
                                                </button>

                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default VerificationPopup;